import BulletinCreateUpdate from "features/bulletins/components/BulletinCreateUpdate";
import { ReactComponent as IconCreatePost } from "assets/images/icons/pencil-square.svg";
import Button from "components/ui/Button/Button";
import { useHistory } from "react-router-dom";
import { useDialog } from "context/DialogContext";
import PropTypes from "prop-types";
import BulletinCreateButton from "features/bulletins/components/BulletinCreateButton";

const MarketplaceCreateButton = ({ categoryId }) => {
  const history = useHistory();
  const { showDialog } = useDialog();

  const handleClick = () => {
    showDialog(
      <BulletinCreateUpdate
        categoryId={ categoryId }
        isMarketPlace={ true }
        onCompleted={ bulletin => history.push(bulletin.url) }/>
    );
  }

  return (
    <Button variant="secondary" onClick={ handleClick }>
      <IconCreatePost/>
      { `Plaats nieuw vraag & aanbod` }
    </Button>
  )
}

BulletinCreateButton.propTypes = {
  categoryId: PropTypes.number.isRequired,
}

export default MarketplaceCreateButton;
